"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportEmailLink = void 0;
var react_1 = __importDefault(require("react"));
var config_1 = require("@app/shared/config");
var SupportEmailLink = function () { return (react_1.default.createElement("a", { href: "mailto:" + config_1.Config.CONTACT_EMAIL }, config_1.Config.CONTACT_EMAIL)); };
exports.SupportEmailLink = SupportEmailLink;
